var map = {
	"./bg01.jpg": 29019,
	"./bg02.jpg": 82062,
	"./bg03.jpg": 52323,
	"./bg04.jpg": 94047,
	"./bg05.jpg": 5732,
	"./bg06.jpg": 45287,
	"./bg07.jpg": 13161,
	"./bg08.jpg": 58472,
	"./bg09.jpg": 91953,
	"./bg10.jpg": 24647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81864;